import axios from 'axios';
import { fetchBusinessLogoBlob } from './api';

// Module-level cache for the ticket logo blob URL. Without it, every
// DeliveryTicketModal mount re-fetches the blob and spins up a new
// object URL, which causes a visible "LOGO" placeholder flash each time
// the modal opens. One fetch per session is enough.

let cached: Promise<string | null> | undefined;
let currentUrl: string | null = null;

async function load(): Promise<string | null> {
  try {
    const res = await fetchBusinessLogoBlob();
    if (currentUrl) URL.revokeObjectURL(currentUrl);
    currentUrl = URL.createObjectURL(res.data);
    return currentUrl;
  } catch (err) {
    if (axios.isAxiosError(err) && err.response?.status === 404) {
      currentUrl = null;
      return null;
    }
    // Transient failure — drop the cached promise so the next caller retries.
    cached = undefined;
    throw err;
  }
}

export function getBusinessLogoUrl(): Promise<string | null> {
  if (cached === undefined) cached = load();
  return cached;
}

// Sync read for components that want to avoid a placeholder flash on
// mount; returns null until the prime fetch finishes or if there's no
// configured logo.
export function getBusinessLogoUrlSync(): string | null {
  return currentUrl;
}

export function invalidateBusinessLogo(): void {
  if (currentUrl) URL.revokeObjectURL(currentUrl);
  currentUrl = null;
  cached = undefined;
}
